"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _webexCore = require("@webex/webex-core");
var _space = _interopRequireDefault(require("./space"));
var _device = _interopRequireDefault(require("./device"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

var Lyra = _webexCore.WebexPlugin.extend({
  /**
   * @typedef {Object} Endpoint
   * @property {Object} advertiser
   * @property {string} advertiser.id
   * @property {string} advertiser.displayName
   * @property {string} advertiser.orgId
   * @property {Object} links
   * @property {Object} links.addMeToSpace
   * @property {string} links.addMeToSpace.href
   * @property {string} links.addMeToSpace.method
   * @property {Object} links.lyra_space
   * @property {string} links.lyra_space.href
   * @property {string} links.lyra_space.method
   * @property {string} proof
   * @property {Object} token
   * @property {string} token.value
   */
  namespace: 'Lyra',
  children: {
    space: _space.default,
    device: _device.default
  },
  /**
   * Get the endpoint information
   * @param {string} token - ultrasound token decoded
   * @returns {Promise<Endpoint>}
   */
  getAdvertisedEndpoint: function getAdvertisedEndpoint(token) {
    return this.webex.request({
      method: 'GET',
      api: 'proximity',
      resource: '/ultrasound/advertisements',
      qs: {
        token: token
      }
    }).then(function (res) {
      return res.body;
    });
  },
  version: "2.59.4"
});
var _default = Lyra;
exports.default = _default;
//# sourceMappingURL=lyra.js.map
